import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SFPillStepper, SFTypography } from "@sf-core";
import PROFICIENCY_LEVELS from "../../constants/proficiencyLevels";

const ProficiencyLevels = ({ proficiencyLevels, inDrawer = false, defaultActiveStep }) => {
  const { t } = useTranslation();

  const PillContent = ({ profLevel }) => (
    <SFTypography variant="body2" hasHtml>
      {proficiencyLevels[profLevel]}
    </SFTypography>
  );

  const steps = useMemo(() => {
    return [
      {
        label: t("profileScreen.detailsDialog.proficiencyLevel.entryLabel"),
        content: <PillContent profLevel={PROFICIENCY_LEVELS.ENTRY} />,
      },
      {
        label: t(
          "profileScreen.detailsDialog.proficiencyLevel.intermediateLabel"
        ),
        content: <PillContent profLevel={PROFICIENCY_LEVELS.INTERMEDIATE} />,
      },
      {
        label: t("profileScreen.detailsDialog.proficiencyLevel.advancedLabel"),
        content: <PillContent profLevel={PROFICIENCY_LEVELS.ADVANCED} />,
      },
      {
        label: t("profileScreen.detailsDialog.proficiencyLevel.masteryLabel"),
        content: <PillContent profLevel={PROFICIENCY_LEVELS.MASTERY} />,
      },
    ];
  }, [proficiencyLevels]);

  return <SFPillStepper steps={steps} inDrawer={inDrawer} defaultActiveStep={defaultActiveStep} />;
};

export default ProficiencyLevels;
